// material-ui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { CardActions, List, ListItemButton, ListItemText } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useParams } from 'react-router-dom'

import {
  Button,
  Divider,
  Grid,
  ListItemAvatar,
  Typography,
} from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import RedQuickInputTags from 'components/RedQuickInputTags'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import SubCard from 'ui-component/cards/SubCard'

import { gridSpacing } from 'store/constant'

import { ApprovalRequestStatus, MediaStatus } from 'features/enumerations'

// assets
import Busy from 'components/Busy'
import MediaDescriptionForm from 'components/MediaDescriptionForm'
import MediaForm from 'components/MediaForm'
import SeriesForm from 'components/SeriesForm'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_approvalRequest,
  get_selected_approvalRequest,
  is_approvalRequest_busy,
  setSelectedapprovalRequest,
} from 'features/approvalRequest/approvalRequest-slice'
import * as autoThunks from 'features/auto-thunks'
import { get_all_media, get_selected_media } from 'features/media/media-slice'
import { get_selected_series } from 'features/series/series-slice'
import ViewMediaThumbnail from 'features/view/media/thumbnail/view-media-thumbnail'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let approvalRequest_list = useSelector(get_all_approvalRequest)
  let approvalRequest_busy = useSelector(is_approvalRequest_busy)
  let approvalRequest = useSelector(get_selected_approvalRequest)
  let series = useSelector(get_selected_series)
  let media_list = useSelector(get_all_media)
  let media = useSelector(get_selected_media)
  const [currentSeries, setCurrentSeries] = React.useState(null)
  const [currentMedia, setCurrentMedia] = React.useState(null)
  const [currentContentHouseId, setCurrentContentHouseId] = React.useState(null)
  const [isMedia, setIsMedia] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [activeStep, setActiveStep] = React.useState(null)
  const [mediaFilter, setMediaFilter] = React.useState(null)
  const [rejectingCurrent, setRejectingCurrent] = React.useState(null)
  const [rejectionReason, setRejectionReason] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_pending_approval_requests({
          ok: (() => {
            function _(): any {
              return true
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && currentSeries) {
      dispatch(
        autoThunks.fetch_series_for_approval_evaluation({
          seriesId: (() => {
            function get_selected_series_id(): any {
              return currentSeries
            }
            return get_selected_series_id()
          })(),
        }),
      )
    }
  }, [claims?.player, currentSeries])
  useEffect(() => {
    if (claims?.player && currentMedia && currentContentHouseId) {
      dispatch(
        autoThunks.fetch_media_for_approval_evaluation({
          mediaId: (() => {
            function get_selected_media_id(): any {
              return currentMedia
            }
            return get_selected_media_id()
          })(),
          contentHouseId: (() => {
            function get_selected_content_house_id(): any {
              return currentContentHouseId
            }
            return get_selected_content_house_id()
          })(),
        }),
      )
    }
  }, [claims?.player, currentMedia, currentContentHouseId])
  useEffect(() => {
    if (claims?.player && series?.id) {
      dispatch(
        autoThunks.fetch_season_for_series_approval_evaluation({
          seriesId: (() => {
            function get_selected_series_id(): any {
              return currentSeries
            }
            return get_selected_series_id()
          })(),
        }),
      )
    }
  }, [
    claims?.player,
    series?.id,
    approvalRequest?.updated,
    approvalRequest?.created,
  ])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_my_approvals({ playerId: claims?.player }))
    }
  }, [claims?.player, approvalRequest?.player?.id])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_processing_approval_requests({
          ok: (() => {
            function _(): any {
              return true
            }
            return _()
          })(),
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && currentContentHouseId) {
      dispatch(
        autoThunks.fetch_medias_for_approval_evaluation({
          contentHouseId: (() => {
            function get_selected_content_house_id(): any {
              return currentContentHouseId
            }
            return get_selected_content_house_id()
          })(),
        }),
      )
    }
  }, [claims?.player, currentContentHouseId])
  useEffect(() => {
    if (claims?.player && claims?.user) {
      dispatch(
        autoThunks.fix_player({
          userId: claims?.user,
          playerId: claims?.player,
        }),
      )
    }
  }, [claims?.player, claims?.user])

  function can_approve_series() {
    if (
      series?.id &&
      approvalRequest?.series?.id &&
      series?.id === approvalRequest?.series?.id
    ) {
      return series?.seasons.some((season) => {
        return !season.media.some((y) => {
          let media = media_list.find((v) => v.id === y.id)
          return media?.mediaStatus !== MediaStatus.Approved
        })
      })
    }
    return false
  }

  function series_media_forms(
    assignApprovalRequst: any,
    unassignApprovalRequest: any,
    approveRequest: any,
    rejectRequest: any,
  ): any {
    return (
      <>
        {isMedia && media && (
          <rq.RedQuickStepper
            title={TitleService('Validate Media')}
            backButtonTitle={TitleService('Back')}
            nextButtonTitle={TitleService('Next')}
            content={[
              (media || series) && media && (
                <>
                  <CardActions>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="flex-end"
                          spacing={2}
                        >
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Pending &&
                            !approvalRequest?.player?.id && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to self')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.player?.id === claims?.player && (
                            <Grid item>
                              <Button
                                variant="outline"
                                disabled={approvalRequest_busy}
                                onClick={async () => {
                                  await dispatch(unassignApprovalRequest)
                                }}
                              >
                                {TitleService('Unassign')}
                              </Button>
                            </Grid>
                          )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button variant="outline" disabled>
                                  {TitleService('Assigned to')}{' '}
                                  {approvalRequest?.player?.firstName}{' '}
                                  {approvalRequest?.player?.lastName}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to me')}
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Typography variant="h5" sx={{ m: 0 }}></Typography>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  {false && (
                    <List component="nav">
                      {Object.entries(approvalRequest).map(([key, value]) => (
                        <React.Fragment key={key}>
                          <ListItemButton>
                            <ListItemAvatar>
                              <FiberManualRecordIcon
                                sx={{
                                  fontSize: '0.875rem',
                                }}
                              />
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Grid
                                  container
                                  alignItems="center"
                                  spacing={1}
                                  component="span"
                                >
                                  <Grid item xs zeroMinWidth component="span">
                                    <Typography
                                      variant="h5"
                                      color="inherit"
                                      component="span"
                                      sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: 'block',
                                      }}
                                    >
                                      {key}
                                    </Typography>
                                  </Grid>
                                  <Grid item component="span">
                                    <Typography
                                      component="span"
                                      variant="subtitle2"
                                    >
                                      {JSON.stringify(value)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              }
                            />
                          </ListItemButton>
                          <Divider />
                        </React.Fragment>
                      ))}
                    </List>
                  )}
                  <Divider />
                </>
              ),
              isMedia && media && media && (
                <Grid container spacing={gridSpacing}>
                  <Grid item xs={12} sm={6} md={6}>
                    <MediaDescriptionForm
                      page="approval-view"
                      form={media.description}
                      onUpdate={() => {}}
                      context={{
                        mediaRel: {
                          title: 'Video',
                          componentTitle: 'Video',
                          accept: 'video/mp4,video/x-m4v,video/*',
                          uploadOnce: true,
                          unwrapped: true,
                          limit: 0,
                          video: true,
                          viewOnly: true,
                          description: 'Upload your new video',
                          contextId: contextId,
                          storageLocation: `media/${params?.id}/media_mediaRel`,
                        },
                      }}
                    />
                    <RedQuickInputTags
                      disabled
                      value={(media.tag || []).map((v) => v.name)}
                      onUpdate={() => {}}
                    />
                  </Grid>
                </Grid>
              ),
              (media || series) && media && (
                <Grid item xs={12} sm={6} md={6}>
                  <ViewMediaThumbnail
                    propertyName="thumbnails"
                    context={{
                      thumbnails: {
                        title: 'Thumbnails',
                        componentTitle: 'Thumbnails',
                        accept: 'image/*',
                        unwrapped: true,
                        uploadOnce: false,
                        viewOnly: true,
                        limit: 5,
                        description: 'Upload thumbnails for your video',
                        contextId: contextId,
                        storageLocation: `media/${params?.id}/thumbnails`,
                      },
                    }}
                    removeSelected={() => {}}
                    onSelect={() => {}}
                    value={[media.thumbnail]}
                    onChange={() => {}}
                  />
                </Grid>
              ),
              isMedia && media && (
                <MediaForm
                  form={media}
                  page="view-approval-requests"
                  context={{
                    mediaRel: {
                      title: 'Video',
                      componentTitle: 'Video',
                      accept: 'video/mp4,video/x-m4v,video/*',
                      uploadOnce: true,
                      limit: 0,
                      unwrapped: true,
                      video: true,
                      viewOnly: true,
                      description: 'Upload your new video',
                      contextId: contextId,
                      storageLocation: `media/${params?.id}/media_mediaRel`,
                    },
                    thumbnail: {
                      image: true,
                      title: 'Media Thumbnail',
                      componentTitle: 'Media Thumbnail',
                      contextId: contextId,
                      aspectRatio: 16 / 9,
                      uploadOnce: true,
                      limit: 0,
                      unwrapped: true,
                      description: 'Upload thumbnail title image for media',
                      maxSize: 4000,
                      onStorageLocation: (location: string) => {
                        setNewMedia({
                          ...newMedia,
                          thumbnailLocation: location,
                        })
                      },
                    },
                    transparentTitleUrl: {
                      image: true,
                      title: 'Media Transparent Title Image',
                      componentTitle: 'Media Transparent Title Image',
                      contextId: contextId,
                      aspectRatio: 16 / 9,
                      uploadOnce: true,
                      limit: 0,
                      unwrapped: true,
                      description: 'Upload cover title image for media',
                      maxSize: 4000,
                      onStorageLocation: (location: string) => {
                        setNewMedia({
                          ...newMedia,
                          transparentTitleLocation: location,
                        })
                      },
                    },
                    mediaPreviewUrl: {
                      title: 'Video',
                      componentTitle: 'Video',
                      accept: 'video/mp4,video/x-m4v,video/*',
                      uploadOnce: true,
                      limit: 0,
                      unwrapped: true,
                      video: true,
                      viewOnly: true,
                      description: 'Upload your new video',
                      contextId: contextId,
                      storageLocation: `media/${params?.id}/media_mediaRel`,
                    },
                  }}
                />
              ),
              isMedia && media && (
                <>
                  <CardActions>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="flex-end"
                          spacing={2}
                        >
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Pending &&
                            !approvalRequest?.player?.id && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to self')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id === claims?.player && (
                              <Grid item>
                                <Button
                                  variant="outline"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(unassignApprovalRequest)
                                  }}
                                >
                                  {TitleService('Unassign')}
                                </Button>
                              </Grid>
                            )}
                          {[
                            ApprovalRequestStatus.Processing,
                            ApprovalRequestStatus.Pending,
                          ].some((v) => v === approvalRequest?.status) &&
                            claims?.player && (
                              <Grid item>
                                <RedQuickAlert
                                  button={
                                    <Button
                                      variant="contained"
                                      sx={{
                                        background: theme.palette.success.dark,
                                        '&:hover': {
                                          background:
                                            theme.palette.success.main,
                                        },
                                      }}
                                      disabled={approvalRequest_busy}
                                      onClick={async () => {
                                        setRejectingCurrent(false)
                                      }}
                                    >
                                      {TitleService('Approve')}
                                    </Button>
                                  }
                                  cancelText={TitleService('No')}
                                  affirmativeText={TitleService('Yes')}
                                  title={TitleService('Are you sure?')}
                                  onOk={async () => {
                                    await dispatch(approveRequest)
                                  }}
                                  description={TitleService(
                                    'Have you checked all the resources?',
                                  )}
                                />
                              </Grid>
                            )}
                          {[
                            ApprovalRequestStatus.Processing,
                            ApprovalRequestStatus.Pending,
                          ].some((v) => v === approvalRequest?.status) &&
                            claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  sx={{
                                    background: theme.palette.error.main,
                                    '&:hover': {
                                      background: theme.palette.error.dark,
                                    },
                                  }}
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    setRejectingCurrent(true)
                                  }}
                                >
                                  {TitleService('Reject')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button variant="outline" disabled>
                                  {TitleService('Assigned to')}{' '}
                                  {approvalRequest?.player?.firstName}{' '}
                                  {approvalRequest?.player?.lastName}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to me')}
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Typography variant="h5" sx={{ m: 0 }}></Typography>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  {claims?.player && rejectingCurrent && (
                    <>
                      <CardActions>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={2}
                        >
                          <Grid item xs={12}>
                            <rq.RedQuickTextArea
                              value={rejectionReason}
                              onChange={(val) => {
                                setRejectionReason(val)
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="flex-end"
                              spacing={2}
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  sx={{
                                    background: theme.palette.info.main,
                                    '&:hover': {
                                      background: theme.palette.info.dark,
                                    },
                                  }}
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    setRejectingCurrent(false)
                                  }}
                                >
                                  {TitleService('Cancel')}
                                </Button>
                              </Grid>
                              <Grid item>
                                {claims?.player && (
                                  <Grid item>
                                    <RedQuickAlert
                                      button={
                                        <Button
                                          variant="contained"
                                          sx={{
                                            background:
                                              theme.palette.error.main,
                                            '&:hover': {
                                              background:
                                                theme.palette.error.dark,
                                            },
                                          }}
                                          disabled={approvalRequest_busy}
                                          onClick={async () => {
                                            setRejectingCurrent(false)
                                          }}
                                        >
                                          {TitleService('Reject')}
                                        </Button>
                                      }
                                      cancelText={TitleService('No')}
                                      affirmativeText={TitleService('Yes')}
                                      onOk={async () => {
                                        setRejectingCurrent(false)
                                        await dispatch(rejectRequest)
                                      }}
                                      title={TitleService('Are you sure?')}
                                      description={TitleService(
                                        'Give a thorough explanation.',
                                      )}
                                    />
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardActions>
                      <Divider />
                    </>
                  )}
                </>
              ),
            ]}
            errorIndex={null}
            completePanel={
              (media || series) && (
                <>
                  <CardActions></CardActions>
                  <Divider />
                </>
              )
            }
            steps={[
              'Assign Approval',
              'Basic Information',
              'Validate Thumbnails',
              'Validate Video',
              'Complete',
            ]}
          />
        )}
        {!isMedia && series && (
          <rq.RedQuickStepper
            title={TitleService('Validate Series')}
            backButtonTitle={TitleService('Back')}
            nextButtonTitle={TitleService('Next')}
            content={[
              (media || series) && (
                <>
                  <CardActions>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="flex-end"
                          spacing={2}
                        >
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Pending &&
                            !approvalRequest?.player?.id && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to self')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.player?.id === claims?.player && (
                            <Grid item>
                              <Button
                                variant="outline"
                                disabled={approvalRequest_busy}
                                onClick={async () => {
                                  await dispatch(unassignApprovalRequest)
                                }}
                              >
                                {TitleService('Unassign')}
                              </Button>
                            </Grid>
                          )}
                          {approvalRequest?.player?.id &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button variant="outline" disabled>
                                  {TitleService('Assigned to')}{' '}
                                  {approvalRequest?.player?.firstName}{' '}
                                  {approvalRequest?.player?.lastName}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to me')}
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Typography variant="h5" sx={{ m: 0 }}></Typography>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                </>
              ),
              !isMedia && (
                <SeriesForm
                  page="view-media-url"
                  context={{
                    titleMediaUrl: {
                      title: 'Series Intro',
                      componentTitle: 'Series Intro',
                      accept: 'video/mp4,video/x-m4v,video/*',
                      uploadOnce: false,
                      unwrapped: true,
                      limit: 0,
                      viewOnly: true,
                      description: 'Upload your series intro clip.',
                      contextId: contextId,
                      video: true,
                    },
                    titleMediaImageUrl: {
                      image: true,
                      title: 'Series Coverage Image',
                      componentTitle: 'Series Coverage Image',
                      contextId: contextId,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 4000,
                    },
                    titleTransparentUrl: {
                      image: true,
                      title: 'Series Title Image',
                      componentTitle: 'Series Title Image',
                      contextId: contextId,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 500,
                    },
                  }}
                  form={series}
                />
              ),
              !isMedia && (
                <SeriesForm
                  page="view-media-image-url"
                  context={{
                    titleMediaUrl: {
                      title: 'Series Intro',
                      componentTitle: 'Series Intro',
                      accept: 'video/mp4,video/x-m4v,video/*',
                      uploadOnce: false,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload your series intro clip.',
                      contextId: contextId,
                      video: true,
                    },
                    titleMediaImageUrl: {
                      image: true,
                      title: 'Series Coverage Image',
                      componentTitle: 'Series Coverage Image',
                      contextId: contextId,
                      unwrapped: true,
                      limit: 0,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 4000,
                    },
                    titleTransparentUrl: {
                      image: true,
                      title: 'Series Title Image',
                      componentTitle: 'Series Title Image',
                      contextId: contextId,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 500,
                    },
                  }}
                  form={series}
                />
              ),
              !isMedia && (
                <SeriesForm
                  page="view-title-image-url"
                  context={{
                    titleMediaUrl: {
                      title: 'Series Intro',
                      componentTitle: 'Series Intro',
                      accept: 'video/mp4,video/x-m4v,video/*',
                      uploadOnce: false,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload your series intro clip.',
                      contextId: contextId,
                      video: true,
                    },
                    titleMediaImageUrl: {
                      image: true,
                      title: 'Series Coverage Image',
                      componentTitle: 'Series Coverage Image',
                      contextId: contextId,
                      unwrapped: true,
                      limit: 0,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 4000,
                    },
                    titleTransparentUrl: {
                      image: true,
                      title: 'Series Title Image',
                      componentTitle: 'Series Title Image',
                      contextId: contextId,
                      limit: 0,
                      unwrapped: true,
                      viewOnly: true,
                      description: 'Upload cover image for series',
                      maxSize: 500,
                    },
                  }}
                  form={series}
                />
              ),
              !isMedia && series?.seasons && media_list && (
                <Grid item xs={12}>
                  <Typography variant="h3" sx={{ m: 0 }}>
                    {TitleService('Seasons')}
                  </Typography>
                  {!isMedia &&
                    series?.seasons &&
                    media_list &&
                    SC.displaySeasonList(series?.seasons, media_list, theme)}
                </Grid>
              ),
              series && (
                <>
                  <CardActions>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="flex-end"
                          spacing={2}
                        >
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Pending &&
                            !approvalRequest?.player?.id && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to self')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id === claims?.player && (
                              <Grid item>
                                <Button
                                  variant="outline"
                                  disabled={approvalRequest_busy}
                                  onClick={async () => {
                                    await dispatch(unassignApprovalRequest)
                                  }}
                                >
                                  {TitleService('Unassign')}
                                </Button>
                              </Grid>
                            )}
                          {[
                            ApprovalRequestStatus.Processing,
                            ApprovalRequestStatus.Pending,
                          ].some((v) => v === approvalRequest?.status) &&
                            claims?.player && (
                              <Grid item>
                                <RedQuickAlert
                                  button={
                                    <Button
                                      variant="contained"
                                      sx={{
                                        background: theme.palette.success.dark,
                                        '&:hover': {
                                          background:
                                            theme.palette.success.main,
                                        },
                                      }}
                                      disabled={
                                        approvalRequest_busy ||
                                        !can_approve_series()
                                      }
                                      onClick={async () => {
                                        setRejectingCurrent(false)
                                      }}
                                    >
                                      {TitleService('Approve')}
                                    </Button>
                                  }
                                  cancelText={TitleService('No')}
                                  affirmativeText={TitleService('Yes')}
                                  title={TitleService('Are you sure?')}
                                  onOk={async () => {
                                    await dispatch(approveRequest)
                                  }}
                                  description={TitleService(
                                    'Have you checked all the resources?',
                                  )}
                                />
                              </Grid>
                            )}
                          {[
                            ApprovalRequestStatus.Processing,
                            ApprovalRequestStatus.Pending,
                          ].some((v) => v === approvalRequest?.status) &&
                            claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  sx={{
                                    background: theme.palette.error.main,
                                    '&:hover': {
                                      background: theme.palette.error.dark,
                                    },
                                  }}
                                  disabled={
                                    approvalRequest_busy ||
                                    !can_approve_series()
                                  }
                                  onClick={async () => {
                                    setRejectingCurrent(true)
                                  }}
                                >
                                  {TitleService('Reject')}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button variant="outline" disabled>
                                  {TitleService('Assigned to')}{' '}
                                  {approvalRequest?.player?.firstName}{' '}
                                  {approvalRequest?.player?.lastName}
                                </Button>
                              </Grid>
                            )}
                          {approvalRequest?.status ===
                            ApprovalRequestStatus.Processing &&
                            approvalRequest?.player?.id !== claims?.player && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  disabled={
                                    approvalRequest_busy ||
                                    !can_approve_series()
                                  }
                                  onClick={async () => {
                                    await dispatch(assignApprovalRequst)
                                  }}
                                >
                                  {TitleService('Assign to me')}
                                </Button>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item>
                        {!can_approve_series() && (
                          <Typography variant="h5" sx={{ m: 0 }}>
                            {TitleService(
                              'Be sure that all the media has been approved first. Thanks.',
                            )}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  {claims?.player && rejectingCurrent && (
                    <>
                      <CardActions>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                          spacing={2}
                        >
                          <Grid item xs={12}>
                            <rq.RedQuickTextArea
                              value={rejectionReason}
                              onChange={(val) => {
                                setRejectionReason(val)
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="flex-end"
                              spacing={2}
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  sx={{
                                    background: theme.palette.info.main,
                                    '&:hover': {
                                      background: theme.palette.info.dark,
                                    },
                                  }}
                                  disabled={
                                    approvalRequest_busy ||
                                    !can_approve_series()
                                  }
                                  onClick={async () => {
                                    setRejectingCurrent(false)
                                  }}
                                >
                                  {TitleService('Cancel')}
                                </Button>
                              </Grid>
                              <Grid item>
                                {claims?.player && (
                                  <Grid item>
                                    <RedQuickAlert
                                      button={
                                        <Button
                                          variant="contained"
                                          sx={{
                                            background:
                                              theme.palette.error.main,
                                            '&:hover': {
                                              background:
                                                theme.palette.error.dark,
                                            },
                                          }}
                                          disabled={
                                            approvalRequest_busy ||
                                            !can_approve_series()
                                          }
                                          onClick={async () => {
                                            setRejectingCurrent(false)
                                          }}
                                        >
                                          {TitleService('Reject')}
                                        </Button>
                                      }
                                      cancelText={TitleService('No')}
                                      affirmativeText={TitleService('Yes')}
                                      onOk={async () => {
                                        setRejectingCurrent(false)
                                        await dispatch(rejectRequest)
                                      }}
                                      title={TitleService('Are you sure?')}
                                      description={TitleService(
                                        'Give a thorough explanation.',
                                      )}
                                    />
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardActions>
                      <Divider />
                    </>
                  )}
                </>
              ),
            ]}
            steps={[
              'Assign Approval',
              'Header Video',
              'Header Image',
              'Header Title Image',
              'Seasons',
              'Complete',
            ]}
          />
        )}
      </>
    )
  }

  let output_series_media_forms = series_media_forms(
    autoThunks.assign_approval_request({
      playerId: claims?.player,
      approvalRequestId: (() => {
        function _get_approval_requst_id(): any {
          return approvalRequest?.id
        }
        return _get_approval_requst_id()
      })(),
    }),
    autoThunks.unassign_approval_request({
      playerId: claims?.player,
      approvalRequestId: (() => {
        function _get_approval_requst_id(): any {
          return approvalRequest?.id
        }
        return _get_approval_requst_id()
      })(),
    }),
    autoThunks.approve_approval_request({
      userId: claims?.user,
      playerId: claims?.player,
      approvalRequestId: (() => {
        function _get_approval_requst_id(): any {
          return approvalRequest?.id
        }
        return _get_approval_requst_id()
      })(),
    }),
    autoThunks.reject_approval_request({
      playerId: claims?.player,
      approvalRequestId: (() => {
        function _get_approval_requst_id(): any {
          return approvalRequest?.id
        }
        return _get_approval_requst_id()
      })(),
      reason: (() => {
        function get_rejection_reason(): any {
          return rejectionReason
        }
        return get_rejection_reason()
      })(),
    }),
  )

  function grid(child1: any): any {
    return (() => {
      return (
        <Grid container spacing={gridSpacing}>
          <Busy />
          <Grid item xs={12} sm={6} md={4}>
            <SubCard title={TitleService('Requests')}>
              <Grid container spacing={gridSpacing}>
                <rq.RedQuickTextField
                  title={TitleService('Filter')}
                  value={mediaFilter || ''}
                  onChange={(val) => {
                    setMediaFilter(val)
                  }}
                />
                <Grid item xs={12}>
                  {SC.approvalRequestList(
                    approvalRequest_list
                      .filter((temp) => {
                        return (
                          temp.status === ApprovalRequestStatus.Pending ||
                          temp.status === ApprovalRequestStatus.Rejected ||
                          temp.status === ApprovalRequestStatus.Processing
                        )
                      })
                      .filter((x) => {
                        if (mediaFilter) {
                          return (
                            `${x?.media?.name || x?.series?.name}`
                              .toLowerCase()
                              .indexOf(`${mediaFilter}`.toLowerCase()) !== -1
                          )
                        }
                        return true
                      })
                      .filter((x) => !x?.media?.deleted)
                      .map((a) => {
                        return {
                          ...a,
                          selected: approvalRequest?.id === a?.id,
                          isApproving:
                            [
                              ApprovalRequestStatus.Processing,
                              ApprovalRequestStatus.Pending,
                              ApprovalRequestStatus.Rejected,
                            ].some((y) => y === a.status) &&
                            a?.player?.id === claims?.player,
                          approvingWithDifferentPlayer:
                            [
                              ApprovalRequestStatus.Processing,
                              ApprovalRequestStatus.Pending,
                              ApprovalRequestStatus.Rejected,
                            ].some((y) => y === a.status) &&
                            a?.player?.id &&
                            a?.player?.id !== claims?.player,
                        }
                      })
                      .sort((a, b) => {
                        let a_is_mine = a?.player?.id === claims?.player
                        let b_is_mine = b?.player?.id === claims?.player
                        if (a_is_mine && b_is_mine) {
                          return 0
                        } else if (a_is_mine) {
                          return 1
                        } else if (b_is_mine) {
                          return -1
                        }
                        return 0
                      }),
                    async (item) => {
                      dispatch(setSelectedapprovalRequest(item.id))
                      if (item?.series?.id) {
                        setCurrentSeries(item?.series?.id)
                        setCurrentContentHouseId(item?.contentHouse?.id)
                        setIsMedia(false)
                      } else if (item?.media?.id) {
                        setCurrentMedia(item?.media?.id)
                        setCurrentContentHouseId(item?.contentHouse?.id)
                        setIsMedia(true)
                      }
                      dispatch(setSelectedapprovalRequest(item.id))
                      await dispatch(
                        autoThunks.fetch_medias_for_approval_evaluation({
                          contentHouseId: (() => {
                            function get_selected_content_house_id(): any {
                              return currentContentHouseId
                            }
                            return get_selected_content_house_id()
                          })(),
                        }),
                      )
                    },
                    theme,
                  )}
                </Grid>
              </Grid>
            </SubCard>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            {child1}
          </Grid>
        </Grid>
      )
    })()
  }

  let output_grid = grid(output_series_media_forms)

  return output_grid
}
